import { CMSService } from 'client/services';
import { hasActiveAccount } from 'client/utils/auth/msalHelpers';

const HomePageLoader = async () => {
    const isAuthenticated = hasActiveAccount();
    if (!isAuthenticated) {
        const homePageAbout = await CMSService.getHomePageAbout();
        return {
            homePageAbout,
            workspaceNotice: null,
            acceptableUsage: null
        };
    }
    const [workspaceNoticeResult, acceptableUsageResult] = await Promise.allSettled([
        CMSService.getWorkspaceNotice(),
        CMSService.getAcceptableUsage()
    ]);

    return {
        homePageAbout: null,
        workspaceNotice: workspaceNoticeResult.status === 'fulfilled' ? workspaceNoticeResult.value : null,
        acceptableUsage: acceptableUsageResult.status === 'fulfilled' ? acceptableUsageResult.value : null
    };
};

export default HomePageLoader;
